function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import classNames from 'classnames';
import icClose from 'assets/svg/ic_close.svg';
import styles from './styles.module.scss';
import Modal from '../Modal';

const PopupModal = ({
  children,
  className,
  header,
  withPortal = false,
  onClose,
  ...props
}) => {
  return /*#__PURE__*/React.createElement(Modal, {
    className: classNames(className),
    withPortal: withPortal
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.modal, header ? null : styles.noneHeader)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.header
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.title
  }, header), /*#__PURE__*/React.createElement("button", _extends({}, props, {
    onClick: onClose,
    className: styles.close
  }), /*#__PURE__*/React.createElement("img", {
    className: styles.icon,
    src: icClose
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, children)));
};

export default PopupModal;